import styled from 'styled-components'

import { NextWrappers } from 'ui'

export const StyledLink = styled(NextWrappers.Link)`
  display: inline-block;
  text-decoration: none;
`
